<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.student.graduationImport')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('form.student.graduationImport')}}</div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="border border-dark p-2 mb-5">
                                    <a href="/templates/CSV-Sample-GraduationImport.csv" class="mb-3 d-block"
                                        download>{{$t('form.import.download')}}</a>

                                    <div class="font-weight-bold">{{$t('form.import.requirement')}}</div>
                                    <ul>
                                        <li>{{$t('form.import.requirement1')}}</li>
                                        <li>{{$t('form.import.requirement2', {format: dateFormat})}}</li>
                                    </ul>
                                </div>
                            </div>

                            <div class="col-md-7">
                                <b-form-checkbox class="mb-4" v-model="header">
                                    {{$t('form.import.csvHeader')}} <br>
                                    <span class="font-weight-normal">{{$t('form.import.csvHeaderText')}}</span>
                                </b-form-checkbox>

                                <b-form-checkbox class="mb-4" v-model="delimiter">
                                    {{$t('form.import.csvDelimiter')}} <br>
                                    <span class="font-weight-normal">{{$t('form.import.csvDelimiterText')}}</span>
                                </b-form-checkbox>

                                <b-form-checkbox class="mb-4" v-model="qualifier">
                                    {{$t('form.import.csvQualifier')}} <br>
                                    <span class="font-weight-normal">{{$t('form.import.csvQualifierText')}}</span>
                                </b-form-checkbox>
                            </div>

                            <div class="col-md-5">
                                <div class="form-group">
                                    <label class="control-label"
                                        for="StatusID:">{{$t('form.student.uploadFile')}}</label>

                                    <vue-dropzone @vdropzone-sending="importingData" ref="myVueDropzone" id="dropzone"
                                        :options="dropzoneOptions" @vdropzone-complete="fileSubmitted"
                                        @vdropzone-processing="isLoading=true">
                                    </vue-dropzone>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import vue2Dropzone from "vue2-dropzone";

    export default {
        props: ['permissions', 'dateFormat'],
        components: {
            vueDropzone: vue2Dropzone,
        },
        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,

                dropzoneOptions: {
                    url: "/api/graduation/import",
                    headers: {
                        "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]")
                            .content,
                        Authorization: "Bearer " + localStorage.getItem("token")
                    },
                    thumbnailWidth: 150, // px
                    thumbnailHeight: 150
                },

                header: true,
                delimiter: true,
                qualifier: false,
            }
        },

        mounted() {
            if (!this.permissions.createImportGraduations) {
                this.$router.push('/');
            }

             let  savedRecordStatus = window.localStorage.getItem('dataSaved');
            if(savedRecordStatus)
            {
                this.showAlert(savedRecordStatus);
                window.localStorage.removeItem('dataSaved');
            }
        },

        methods: {

            importingData(file, xhr, formData) {
                formData.append('heading_row', this.header ? 1 : 0);
                formData.append('delimiter', this.delimiter ? 1 : 0);
                formData.append('qualifier', this.qualifier ? 1 : 0);
            },

            fileSubmitted(response) {
                this.isLoading = false;

                let data = JSON.parse(response.xhr.response);


                if (response.status == 'success') {
                    this.showAlert(data.message);
                    localStorage.setItem('graduations',JSON.stringify(data.data))
                    localStorage.setItem('path', data.data.path)
                    localStorage.setItem('qualifier',this.qualifier ? 1 : 0)

                    this.$router.push({name: 'GraduationImportPreview'});

                } else if (response.status == 'error') {
                    this.showAlert(data.message, 'danger');
                }
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            }
        }
    }

</script>
